import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { Observable } from 'rxjs';
import { IPartner } from 'src/app/state/user/user.models';
import { selectPartner } from 'src/app/state/user/user.selectors';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  currentYear:string;
  logoReale: string = `/assets/icons/${environment.logo}`;
  translateKey:string = 'footer'

  partnerData$:Observable<IPartner>;

  constructor(
    private store:Store,
  ) {
    this.partnerData$ = this.store.select(selectPartner)
    this.currentYear = moment(new Date()).format('YYYY')
  }
  
  ngOnInit(): void {
  }
}
